'use client';

import type { FC, ReactNode } from 'react';
import { useLayoutEffect, useRef } from 'react';
import { useScreenLayout } from './useScreenLayout';
import { useUiMotionEnabled } from '../hooks/useMotion';

interface ScreenFixedBottomProps {
  children: ReactNode;
  className?: string;
  showBlur?: boolean;
}

export const ScreenFixedBottom: FC<ScreenFixedBottomProps> = ({ children, className, showBlur }) => {
  const { setFixedBottom, clearFixedBottom } = useScreenLayout();
  const motionEnabled = useUiMotionEnabled();

  const motionRef = useRef(motionEnabled);
  motionRef.current = motionEnabled;

  const blur = showBlur ?? (children != null && children !== false);

  useLayoutEffect(() => {
    setFixedBottom(children, className, blur, motionRef.current);
  }, [children, className, blur, setFixedBottom]);

  useLayoutEffect(() => () => clearFixedBottom(motionRef.current), [clearFixedBottom]);

  return null;
};
